<template>
  <div class = "form__row">
    <div class = "bordered-panel">
      <div class = "form__row">
        <div class="arena-text-title" @click = "toggleBlock">
          <div class = "inline-text-container">
            <h3>{{title}}</h3>
          </div>
          <p class = "inline-text-container">({{keyDescription}})</p>
          <span class="arrow-down"></span>
        </div>
      </div>

      <p class = "preview-badge" v-if = "!isOpen && value">
        {{value}}
      </p>

      <div v-if="isOpen">
        <div class = "form__row">
          <label class = "form__label">Global text</label>

          <p class = "preview-badge">
            {{globalText}}
          </p>
        </div>

        <div class = "form__row">
          <label class = "form__label">Custom text</label>
          <div class = "multiple-inputs-wrap">
            <div class = "form__input-box">
              <input
                type = "text"
                class = "form__input"
                v-bind:value="value"
                v-on:input="$emit('input', $event.target.value.trim())"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ArenaTextEditBlock',
    props: ['value', 'globalText', 'title', 'keyDescription'], // value is a predefined prop name which is injected by v-model directive
    data () {
      return {
        isOpen: false
      }
    },
    methods: {
      toggleBlock () {
        this.isOpen = !this.isOpen
      }
    }
  }
</script>

<style scoped lang = "scss" src = "./ArenaTextEditForm.scss"></style>
